export default function showDescription(value) {
  return value?.description || value?.value || value?.name || value
}
